
import Page from '@/Page.vue';
import { Component, VModel, Watch } from 'vue-property-decorator';
import ShiftManagementDetail from '@/libs/shifts/components/ShiftManagementDetail.vue';

@Component({
    components: { ShiftManagementDetail },
})
export default class LocationShifts extends Page {
    @VModel() shiftId!: string | null | undefined;
    protected dialog = false;

    @Watch('shiftId', { immediate: true })
    onShiftIdChanged(v: string | null | undefined) {
        this.dialog = v != undefined && true && v.length > 0;
    }

    onCloseClick() {
        this.$emit('input', null);
    }
}
